module.exports = __webpack_public_path__ + "img/anonym.13e953b3.jpg";